var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "196px",
    viewBox: "0 0 214 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-11---LegalSite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.5--LegalSite--page-not-found",
    transform: "translate(-614.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(615.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(5.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.243697,93.4061382 C194.243697,41.8202632 152.650421,0 101.344538,0 C50.0386544,0 8.44537815,41.8202632 8.44537815,93.4061382 C8.44537815,107.150851 11.4227962,120.188013 16.7226933,131.93617 L185.966382,131.93617 C191.266279,120.188013 194.243697,107.150851 194.243697,93.4061382",
    id: "Fill-1",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,131.93617 L5.06722689,131.93617",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.932773,131.93617 L201,131.93617",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1344538,131.93617 L190.865546,131.93617",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(44.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.205479,114.929577 C111.205479,117.730382 88.9500483,120 61.5,120 C34.0467958,120 11.7945205,117.730382 11.7945205,114.929577 C11.7945205,112.128773 34.0467958,109.859155 61.5,109.859155 C88.9500483,109.859155 111.205479,112.128773 111.205479,114.929577",
    id: "Fill-9",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L122.987404,7.88419405 C122.987404,3.53051643 119.435239,0 115.051717,0 L7.93253796,0 C3.55216467,0 0,3.53051643 0,7.88419405 L0.0125963286,70.9859155 L123,70.9859155 Z",
    id: "Fill-11",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9308362,70.9859155 L87.6164384,0 L7.96225723,0 C3.56547287,0 0,3.53051643 0,7.88419405 L0.0126435208,70.9859155 L15.9308362,70.9859155 Z",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L123,86.7605634 C123,91.1173709 119.447472,94.6478873 115.060351,94.6478873 L7.9333504,94.6478873 C3.55252849,94.6478873 0,91.1173709 0,86.7605634 L0,70.9859155 L123,70.9859155 Z",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L123,86.7605634 C123,91.1173709 119.447472,94.6478873 115.060351,94.6478873 L7.9333504,94.6478873 C3.55252849,94.6478873 0,91.1173709 0,86.7605634 L0,70.9859155 L123,70.9859155 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7123288,83.6619718 C65.7123288,85.9959759 63.8301533,87.8873239 61.5,87.8873239 C59.1731898,87.8873239 57.2876712,85.9959759 57.2876712,83.6619718 C57.2876712,81.3313213 59.1731898,79.4366197 61.5,79.4366197 C63.8301533,79.4366197 65.7123288,81.3313213 65.7123288,83.6619718",
    id: "Fill-19",
    fill: "#F4F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7123288,83.6619718 C65.7123288,85.9959759 63.8301533,87.8873239 61.5,87.8873239 C59.1731898,87.8873239 57.2876712,85.9959759 57.2876712,83.6619718 C57.2876712,81.3313213 59.1731898,79.4366197 61.5,79.4366197 C63.8301533,79.4366197 65.7123288,81.3313213 65.7123288,83.6619718 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "80.8767123 111.549296 40.4383562 111.549296 42.460274 96.3380282 78.8547945 96.3380282"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "80.8767123 111.549296 40.4383562 111.549296 42.460274 96.3380282 78.8547945 96.3380282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6438356,111.549296 L92.6712329,111.549296",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,70.9859155 L122.987404,7.88419405 C122.987404,3.53051643 119.435239,0 115.051717,0 L7.93253796,0 C3.55216467,0 0,3.53051643 0,7.88419405 L0.0125963286,70.9859155 L123,70.9859155 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 17.000000)",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 20.307692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97916079,10.0790283 L4.97916079,1.41220369e-13",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84217094e-14,5.03987935 L9.96120837,5.03987935",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(126.680672, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37815126,6.76923077 L3.37815126,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.38461538 L6.75630252,3.38461538",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(194.243697, 20.307692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37815126,6.76923077 L3.37815126,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.38461538 L6.75630252,3.38461538",
    id: "Stroke-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(184.109244, 103.230769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37815126,6.76923077 L3.37815126,0",
    id: "Stroke-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.38461538 L6.75630252,3.38461538",
    id: "Stroke-69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(66.000000, 78.000000)",
    fill: "#7450C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6666667,21.6 L71.6666667,21.6 L71.6666667,32.4 C71.6666667,34.3884374 73.308073,36 75.3333333,36 C77.3585937,36 79,34.3884374 79,32.4 L79,3.6 C79,1.61156256 77.3585937,0 75.3333333,0 C73.308073,0 71.6666667,1.61156256 71.6666667,3.6 L71.6666667,14.4 L64.3333333,14.4 L64.3333333,3.6 C64.3333333,1.61156256 62.691927,0 60.6666667,0 C58.6414063,0 57,1.61156256 57,3.6 L57,18 C57,19.9884374 58.6414063,21.6 60.6666667,21.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66666667,21.6 L14.6666667,21.6 L14.6666667,32.4 C14.6666667,34.3884374 16.308073,36 18.3333333,36 C20.3585937,36 22,34.3884374 22,32.4 L22,3.6 C22,1.61156256 20.3585937,0 18.3333333,0 C16.308073,0 14.6666667,1.61156256 14.6666667,3.6 L14.6666667,14.4 L7.33333333,14.4 L7.33333333,3.6 C7.33333333,1.61156256 5.69192702,0 3.66666667,0 C1.64140631,0 0,1.61156256 0,3.6 L0,18 C0,19.9884374 1.64140631,21.6 3.66666667,21.6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5555556,36 L42.4444444,36 C47.1624131,36 51,32.2321874 51,27.6 L51,8.4 C51,3.76781256 47.1624131,0 42.4444444,0 L37.5555556,0 C32.8375869,0 29,3.76781256 29,8.4 L29,27.6 C29,32.2321874 32.8375869,36 37.5555556,36 Z M36.3333333,8.4 C36.3333333,7.73812512 36.8814237,7.2 37.5555556,7.2 L42.4444444,7.2 C43.1185763,7.2 43.6666667,7.73812512 43.6666667,8.4 L43.6666667,27.6 C43.6666667,28.2618749 43.1185763,28.8 42.4444444,28.8 L37.5555556,28.8 C36.8814237,28.8 36.3333333,28.2618749 36.3333333,27.6 L36.3333333,8.4 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.1486265,0.221896096 C30.7644741,-0.0739653654 30.2325709,-0.0739653654 29.8513735,0.221896096 C26.4767429,2.81219338 22.395863,4.62962808 17.9278757,5.27267391 C17.3959724,5.34814877 17,5.81609292 17,6.36554992 L17,16.0112374 C17,24.9504801 22.3515377,32.682125 30.09073,35.9184871 C30.3507716,36.027171 30.6462734,36.027171 30.90927,35.9184871 C38.6425523,32.682125 44,24.9534991 44,16.0112374 L44,6.36253092 C44,5.81307392 43.6040276,5.34814877 43.0691693,5.27267391 C38.604137,4.62962808 34.5262121,2.81219338 31.1486265,0.221896096 Z",
    id: "Stroke-125",
    stroke: "#7450C8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9519129,9.95959699 C42.231511,-3.31986566 63.7613968,-3.31986566 77.0409948,9.95959699 C90.3187439,23.2390596 90.3205929,44.7687259 77.0409948,58.0481886 C64.4991522,70.5899033 44.6074903,71.2721814 31.2483848,60.1246069 L25.6736162,65.6993187 L21.3007048,61.3283009 L26.8754734,55.7517401 C15.7277852,42.3927708 16.4100703,22.5013117 28.9519129,9.95959699",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9519129,9.95959699 C42.231511,-3.31986566 63.7613968,-3.31986566 77.0409948,9.95959699 C90.3187439,23.2390596 90.3205929,44.7687259 77.0409948,58.0481886 C64.4991522,70.5899033 44.6074903,71.2721814 31.2483848,60.1246069 L25.6736162,65.6993187 L21.3007048,61.3283009 L26.8754734,55.7517401 C15.7277852,42.3927708 16.4100703,22.5013117 28.9519129,9.95959699 Z",
    id: "Stroke-15",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,33.5 C27,48.1356449 38.8639437,60 53.4990812,60 C68.1360563,60 80,48.1356449 80,33.5 C80,18.8643551 68.1360563,7 53.4990812,7 C38.8639437,7 27,18.8643551 27,33.5",
    id: "Fill-17",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6854497,60.6487017 C19.1032576,60.2327263 19.6658322,60 20.2522293,60 C20.8404588,60 21.4030334,60.2327263 21.8208413,60.6487017 L27.3512983,66.1809912 C28.2162339,67.0459268 28.2162339,68.4477822 27.3512983,69.3145503 L10.4593989,86.2064497 C8.066166,88.5978501 4.18678316,88.5978501 1.79355029,86.2064497 C-0.597850096,83.8132168 -0.597850096,79.933834 1.79355029,77.5406011 L18.6854497,60.6487017 Z",
    id: "Fill-19",
    fill: "#DFE4EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6854497,60.6487017 C19.1032576,60.2327263 19.6658322,60 20.2522293,60 C20.8404588,60 21.4030334,60.2327263 21.8208413,60.6487017 L27.3512983,66.1809912 C28.2162339,67.0459268 28.2162339,68.4477822 27.3512983,69.3145503 L10.4593989,86.2064497 C8.066166,88.5978501 4.18678316,88.5978501 1.79355029,86.2064497 C-0.597850096,83.8132168 -0.597850096,79.933834 1.79355029,77.5406011 L18.6854497,60.6487017 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,33.5 C27,48.1356449 38.8639437,60 53.4990812,60 C68.1360563,60 80,48.1356449 80,33.5 C80,18.8643551 68.1360563,7 53.4990812,7 C38.8639437,7 27,18.8643551 27,33.5 Z",
    id: "Stroke-23",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/Group 4.883d687e7a973fb828bcb60c4b34afe9.svg";
export { ForwardRef as ReactComponent };